<template>
  <div>
    <v-row>
      <v-col
        v-for="webhookType in webhookTypes"
        :key="webhookType.type"
        cols="12"
        sm="6"
        md="4"
      >
        <v-card
          :class="[
            'webhook-type-card',
            { selected: value === webhookType.type }
          ]"
          @click="selectType(webhookType.type)"
          :disabled="disabled"
          outlined
          hover
        >
          <v-card-text class="text-center">
            <!-- Icono -->
            <v-icon
              :color="value === webhookType.type ? 'primary' : 'grey'"
              size="48"
              class="mb-3"
            >
              {{ getIcon(webhookType.ui.icon) }}
            </v-icon>

            <!-- Label -->
            <div class="text-h6 mb-2">
              {{ webhookType.ui.label }}
            </div>

            <!-- Description -->
            <div class="text-caption text--secondary">
              {{ webhookType.ui.description }}
            </div>

            <!-- Badge de categoría -->
            <v-chip
              v-if="webhookType.ui.category"
              x-small
              class="mt-3"
              :color="getCategoryColor(webhookType.ui.category)"
              text-color="white"
            >
              {{ getCategoryLabel(webhookType.ui.category) }}
            </v-chip>
          </v-card-text>

          <!-- Indicador de selección -->
          <v-overlay
            v-if="value === webhookType.type"
            absolute
            opacity="0.1"
            color="primary"
          >
            <v-icon color="primary" size="64">
              mdi-check-circle
            </v-icon>
          </v-overlay>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: "WebhookTypeSelector",
  props: {
    value: {
      type: String,
      default: null
    },
    webhookTypes: {
      type: Array,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    selectType(type) {
      if (!this.disabled) {
        this.$emit("input", type);
      }
    },
    getIcon(iconName) {
      const iconMap = {
        meta: "mdi-facebook",
        webhook: "mdi-webhook",
        zapier: "mdi-lightning-bolt",
        code: "mdi-code-braces",
        default: "mdi-webhook"
      };
      return iconMap[iconName] || iconMap.default;
    },
    getCategoryColor(category) {
      const colorMap = {
        analytics: "purple",
        integration: "blue",
        automation: "orange",
        advanced: "teal"
      };
      return colorMap[category] || "grey";
    },
    getCategoryLabel(category) {
      const labelMap = {
        analytics: "Analytics",
        integration: "Integración",
        automation: "Automatización",
        advanced: "Avanzado"
      };
      return labelMap[category] || category;
    }
  }
};
</script>

<style scoped>
.webhook-type-card {
  cursor: pointer;
  transition: all 0.3s ease;
  min-height: 200px;
  display: flex;
  align-items: center;
}

.webhook-type-card:not(.selected):hover {
  border-color: rgba(33, 150, 243, 0.5) !important;
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1) !important;
}

.webhook-type-card.selected {
  border-color: var(--v-primary-base) !important;
  border-width: 2px !important;
}

.webhook-type-card[disabled] {
  cursor: not-allowed;
  opacity: 0.6;
}
</style>
